/* eslint-disable max-len */
import React from 'react';
import ReactApexChart from 'react-apexcharts';
import {
  Card,
  CardBody,
  Container,
  Row,
  Col,
  CardHeader,
  FormGroup,
  Label,
  Input,
} from 'reactstrap';

import { format } from 'date-fns';

import saflportalimg from '../../assets/img/logocompleto.png';
import GoToTop from '../../components/GoToTop';
import LayoutAdmin from '../../layouts/admin';
import TotalCard from './TotalCard';
import useDashboard from './useDashboard';

export default function Home() {
  const { totalAtivos, totalInativos, totalLicenciados, totalJustificativas, totalRenuncias, years, sessoes, lastSessao, getSessoesByYear } = useDashboard();
  const chartData = React.useMemo(() => ({
    series: [
      {
        name: 'Presenças',
        data: sessoes.map((sessao) => sessao.total),
      },
      {
        name: 'Total de votos',
        data: sessoes.map((sessao) => sessao.mediaVotos),
      },
    ],
    options: {
      chart: {
        type: 'bar',
        height: 350,
      },
      colors: ['#145f82', '#e67330'],
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '55%',
        },
      },
      dataLabels: {
        enabled: true,
      },
      xaxis: {
        categories: sessoes.map((sessao) => `${format(new Date(`${sessao.data}T12:00:00`), 'dd/MM/yyyy')}`),
      },
      legend: {
        position: 'bottom',
      },
    },
  }), [sessoes]);

  return (
    <LayoutAdmin>
      <Container>
        <GoToTop />
        <Row>
          <Col>
            <Card className="mt-5">
              <CardHeader>
                <div className="d-flex justify-content-center">
                  <h2>Área Administrativa do SAFL PORTAL</h2>
                </div>
              </CardHeader>
              <CardBody>
                <Row className="justify-content-center">
                  <img src={saflportalimg} alt="SAFL PORTAL" width="100%" />
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={8}>
            <Card>
              <CardBody>
                <Row>
                  <Col>
                    <div className="d-flex align-items-center justify-content-between">
                      <FormGroup className="d-flex gap-2 align-items-center">
                        <Label for="selectYear" className="text-nowrap">
                          Seleção de ano:
                        </Label>
                        <Input
                          id="selectYear"
                          name="selectYear"
                          type="select"
                          className="ml-2"
                          onChange={(e) => getSessoesByYear(e.target.value)}
                        >
                          {years.map((year) => (
                            <option key={year} value={year}>
                              {year}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>
                      <h6>Resumo por Sessão</h6>
                      <div style={{ width: '150px' }} />
                    </div>
                    <div id="chart">
                      <ReactApexChart options={chartData.options} series={chartData.series} type="bar" height={350} />
                    </div>
                    <div id="chart pizza">
                      <ReactApexChart
                        options={{
                          chart: { type: 'pie' },
                          labels: ['Ativos', 'Inativos'],
                          colors: ['#145f82', '#e67330'],
                          dataLabels: { enabled: true },
                          legend: { position: 'bottom' },
                        }}
                        series={[totalAtivos, totalInativos]}
                        type="pie"
                        height={250}
                      />
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
          <Col xs={12} sm={4}>
            <Card>
              <CardBody>
                <div className="d-flex flex-column gap-4">
                  <TotalCard title="Deputados Ativos" value={totalAtivos} />
                  <TotalCard title="Deputados Inativos" value={totalInativos} />
                  <TotalCard title="Total Licenciados" value={totalLicenciados} />
                  <TotalCard title="Total Justificativas" value={totalJustificativas} />
                  <TotalCard title="Total Renúncias" value={totalRenuncias} />
                  {lastSessao && (
                    <TotalCard titleTop={`Última Sessão: ${format(new Date(`${lastSessao.data}T12:00:00`), 'dd/MM/yyyy')}`} title="Total de Presenças" value={lastSessao?.total || 0} />
                  )}
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </LayoutAdmin>
  );
}
